import { NoRecordFound } from 'components/Common/Common';
import ConfirmationPop from 'components/Modals/ConfirmationPop';
import ErrorComponent from 'components/shared/ErrorComponent';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import TableLayout from 'components/TableLayout';
import { CLIENT_TYPES, TASK_STATUS_OPTIONS } from 'config/constants';
import { convertToMomentDate, errorMessageToast, formatString, userFullName } from 'helpers/common';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Accordion, Button, Col, Container, Dropdown, Row } from 'react-bootstrap'
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { useGetTaskDetailsStaffQuery, useLazyGetTaskDetailsStaffQuery, useMarkTaskCompleteMutation, useTaskStatusUpdateMutation } from 'store/services/staff';

export const SingleTaskAccordion = ({ tasks, clientId, staffId, taskType }) => {
    const [currentTask, setCurrentTask] = useState(null)

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedOwnerId, setSelectedOwnerId] = useState('');
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [isTaskCompleted, setIsTaskCompleted] = useState('');
    const [detailsList, setDetailsList] = useState({});
    const [loaderObj, setLoaderObj] = useState({})
    const [refetchTaskDetails, setRefetchTaskDetails] = useState(1)
    const [modalType, setModalType] = useState(null)

    const { data, isLoading, isFetching, error } = useGetTaskDetailsStaffQuery({ id: clientId, taskType, clientId: staffId, taskId: currentTask?.associatedTasks?.id }, { skip: true /*(!clientId && !currentTask?.associatedTasks?.id)*/ });
    const [updateStatus, { isLoading: updateStatusLoading }] = useTaskStatusUpdateMutation();
    const [getTaskDetails] = useLazyGetTaskDetailsStaffQuery()
    const [completeTask, { isLoading: completeTaskLoading }] = useMarkTaskCompleteMutation();

    const handleStatusUpdate = (item) => async (status) => {
        try {
            const result = await updateStatus({ id: item?.target_id, status });
            fetchSingleTask(item?.assigned_task_id)
            if (result?.error) console.error("Error updating mdt status", result.error);
            else successMessageToast(result?.data?.message);

        } catch (error) { console.error("Error updating mdt status", error) }
    };


    const fetchSingleTask = async (id) => {
        setLoaderObj((prev) => ({ ...prev, [id]: true }))
        try {
            const detail = await getTaskDetails({ id: clientId, taskType, clientId: staffId, taskId: id }).unwrap();
            setDetailsList((prev) => ({ ...prev, [id]: detail }))
            setLoaderObj((prev) => {
                const updated = { ...prev };
                delete updated[id]; // remove the key
                return updated;
            });
        } catch (err) {
            setDetailsList((prev) => ({ ...prev, [id]: null }))
            setLoaderObj((prev) => {
                const updated = { ...prev };
                delete updated[id]; // remove the key
                return updated;
            }); console.error('Failed to fetch detail:', err);
        }
    }

    console.log('loaderObj', loaderObj)

    useEffect(() => {
        let isCancelled = false;

        const fetchSequentially = async () => {
            const resultMap = {};
            for (const record of tasks) {
                if (isCancelled) {
                    break;
                }
                try {
                    const detail = await getTaskDetails({ id: clientId, taskType, clientId: staffId, taskId: record?.associatedTasks?.id }).unwrap();
                    setDetailsList((prev) => ({ ...prev, [record?.associatedTasks?.id]: detail }))
                    setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: false }))
                } catch (err) {
                    setDetailsList((prev) => ({ ...prev, [record?.associatedTasks?.id]: null }))
                    setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: false }))
                    console.error('Failed to fetch detail:', err);
                }
            }
        };

        if (tasks?.length) {
            for (const record of tasks) {
                setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: true }))
            }
            fetchSequentially();
        }

        return () => {
            isCancelled = true;
        };
    }, [tasks, refetchTaskDetails]);

    const handleCompleteTask = async () => {
        try {
            setShowModal(false);
            let updateStatus = '';
            if (isTaskCompleted === 'completed') {
                updateStatus = 'pending';
            } else {
                updateStatus = 'completed';
            }
            const result = await completeTask({ task_id: selectedTaskId, owner: selectedOwnerId, updateStatus: updateStatus });
            setIsTaskCompleted('');
            setSelectedTaskId('');
            setSelectedOwnerId('');
            setRefetchTaskDetails((prev) => prev + 1)

            if (result?.error) return;

            successMessageToast(result?.data?.message);
            //   navigate(generatePath(CLIENTS, { activeTab: "Groups" }));

        } catch (err) {
            console.log("Error Completing Task", err);
        };
    };


    const column = [
        {
            head: "Schedule Date",
            accessor: "Session Date",
            isComponent: true,
            component: (item) => <>{convertToMomentDate(item?.schedule_date)}</>,
        },
        {
            head: "Attendance",
            accessor: "Tracker",
            component: (item) => <div className='text-capitalize'>{item?.attendance || "--"}</div>,
        },
        {
            head: "Status",
            accessor: "Confirmed",
            sorter: true,
            isComponent: true,
            // component: (item) => (
            //     <p
            //         style={{ width: 110 }}
            //         className={`${item?.status === "pending" ? "redStatus" : "greenStatus"} status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
            //     >
            //         {formatString(item?.status)}
            //     </p>
            // ),
            component: (item) => (
                <div
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown onSelect={handleStatusUpdate(item)}>
                        <Dropdown.Toggle
                            className="border-light text-dark w-100 fw-sbold"
                            style={{ background: "#F3F3F3", height: 40, display: "flex" }}
                            id="dropdown-basic"
                            disabled={item?.status == "pending" && !item?.attendance}
                        >
                            <h6>{TASK_STATUS_OPTIONS?.find(x => x.value === item?.status)?.label || "Select Status"}{" "}</h6>
                            <span className="icn ms-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="5"
                                    viewBox="0 0 10 5"
                                    fill="none"
                                >
                                    <path
                                        d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                        fill="#1C1B1F"
                                    />
                                </svg>
                            </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="w-100"
                        >
                            {
                                TASK_STATUS_OPTIONS?.map((item, index) => {
                                    return <Dropdown.Item hidden={item.value == "in-process"} key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div >
            ),
        },
        {
            head: "Action",
            accessor: "Action",
            isComponent: true,
            component: (item) => {
                const scheduleDate = new Date(item?.schedule_date);
                const currentDate = new Date();
                const isFutureDate = scheduleDate > currentDate;

                return (
                    <div role='button' onClick={() => isFutureDate && errorMessageToast("Cannot access future target plan.")}>
                        <Link
                            target='_blank'
                            onClick={() => isFutureDate && errorMessageToast("Future Date cannot be accessed")}
                            to={{
                                pathname: generatePath('/manage-staff/clients/sessionview/:taskType/:staffId/:clientId/:taskId', {
                                    taskType: 'single',
                                    staffId: staffId,
                                    clientId: clientId,
                                    taskId: item?.assigned_task_id,
                                }),
                                search: `?task_datetime=${encodeURIComponent(moment.utc(item?.schedule_date).format("YYYY-MM-DDTHH:mm:ssZ"))}`
                            }}
                            className={`btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold`}
                            // className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "

                            style={{
                                height: "35px",
                                maxWidth: "100px",
                                pointerEvents: isFutureDate ? 'none' : 'auto', // Disable click if needed
                                opacity: isFutureDate ? 0.5 : 1,              // Visual cue for disabled
                            }}
                        >
                            Target Plan
                        </Link>
                    </div>

                );
            },
        }
    ];

    if (isLoading) return <LoadingIndicator />;
    if (error) return <div>Error: {error.message}</div>;

    const getClientTypeLabel = (clientTypeValue) => {
        const clientType = CLIENT_TYPES.find(type => type.value === clientTypeValue);
        return clientType ? clientType.label : "--";
    };

    const defaultActiveKeys = tasks?.map((_, index) => index.toString())
    console.log('details list end date', detailsList[272]?.tasks[0]?.occurrences[detailsList[272]?.tasks[0]?.occurrences?.length - 1]?.schedule_date)
    return (
        <>
            <ConfirmationPop type={modalType} confirmation={showModal} setConfirmation={setShowModal} confirmHandler={handleCompleteTask} />
            <Accordion defaultActiveKey={defaultActiveKeys} alwaysOpen>
                {
                    tasks?.map((item, index) =>
                        <Accordion.Item key={index} onClick={() => setCurrentTask(item)} eventKey={index.toString()}>
                            <Accordion.Header className='staff-client-accordion'>
                                <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center'>
                                    <div>
                                        <div className='mb-2'>
                                            <span>Title: </span>{item?.associatedTasks?.task_title}
                                        </div>
                                        <div className='text-capitalize'>
                                            <span>Type: </span>{item?.associatedTasks?.task_type == "single" ? "Individual" : (item?.associatedTasks?.task_type || "--")}
                                        </div>
                                    </div>
                                    <div style={{ marginRight: "10px" }}>
                                        <div className='mb-2'>
                                            Start Date: {convertToMomentDate(item?.associatedTasks?.task_datetime) || "--"}
                                        </div>
                                        <div>
                                            End Date: {item?.associatedTasks?.ends_on_data?.endDate ? convertToMomentDate(item?.associatedTasks?.ends_on_data?.endDate) : detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences[detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences?.length - 1]?.schedule_date ? convertToMomentDate(detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences[detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences?.length - 1]?.schedule_date) : "--"}
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                {
                                    loaderObj[item?.associatedTasks?.id] ? (
                                        <div style={{ height: "200px" }}>
                                            <LoadingIndicator />
                                        </div>
                                    ) : error ? (
                                        <ErrorComponent />
                                    ) :
                                        <>
                                            <section className='mt-4'>
                                                <Container fluid>
                                                    <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient)}</h4>
                                                    <Row>
                                                        <Col lg='12'>
                                                            <Row>
                                                                {[
                                                                    // { label: "Last Name", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.lastname },
                                                                    // { label: "First Name", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.firstname },
                                                                    // { label: "DOB", value: convertToMomentDate(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.dob) },
                                                                    { label: "Name of Discipline", value: detailsList[item?.associatedTasks?.id]?.tasks?.[0]?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name },
                                                                    { label: "Supervisor", value: userFullName(detailsList[item?.associatedTasks?.id]?.tasks?.[0]?.associatedTasks?.owner) },
                                                                    // { label: "Categories Name", value: getClientTypeLabel(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.client_type) },
                                                                    // { label: "Grade", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.grade },
                                                                ].map((item, index) => (
                                                                    <Col md="6" sm="6" className='my-2' key={index}>
                                                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                                            <h6 className="m-0 themeBlue fw-bold">
                                                                                <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                                                                {item.label}
                                                                            </h6>
                                                                            <p className="m-0 themeBlue pt-2">{item.value || "--"}</p>
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </section>
                                            <section className='mt-4'>
                                                <Container fluid>
                                                    {
                                                        !detailsList[item?.associatedTasks?.id]?.tasks?.length ? <NoRecordFound /> : detailsList[item?.associatedTasks?.id]?.tasks?.map((item, index) => (
                                                            <div key={index} className='p-4 pb-0 rounded mt-3' style={{ backgroundColor: "#3DA0AA17" }}>
                                                                <div className="pb-4 h-100 rounded d-flex align-items-center">
                                                                    <h6 className="m-0 themeBlue fw-bold">
                                                                        <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                                                        Date
                                                                    </h6>
                                                                    <div className='d-flex ms-2 align-items-center'>
                                                                        {/* <img src={Images.calender_grey_img} alt="calender_grey_img" /> */}
                                                                        <p className="m-0 themeBlue ms-1">
                                                                            {convertToMomentDate(item?.associatedTasks?.createdAt)}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <h5 className='m-0 fw-bold themeBlue text-capitalize'>{item?.associatedTasks?.task_title || "--"}</h5>
                                                                    {/* <Button
                                                                            disabled={item?.associatedTasks?.status === 'completed'}
                                                                            className='commonBtn btn btn-primary p-0'
                                                                            style={{
                                                                                height: "35px",
                                                                                backgroundColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : '',
                                                                                borderColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : ''
                                                                            }}
                                                                        >
                                                                            {item?.associatedTasks?.status === 'completed' ? 'Completed' : 'In complete'}
                                                                        </Button> */}
                                                                    <Button
                                                                        onClick={(e) => {
                                                                            if (item?.associatedTasks?.status !== "completed") {
                                                                                e.stopPropagation();
                                                                                setIsTaskCompleted(item?.associatedTasks?.status)
                                                                                setSelectedTaskId(item?.associatedTasks?.id);
                                                                                setSelectedOwnerId(item?.associatedTasks?.createdBy)
                                                                                setModalType('completeTask')
                                                                                setShowModal(true);
                                                                            }
                                                                        }}
                                                                        className='commonBtn btn btn-primary p-0 mb-2'
                                                                        style={{
                                                                            height: "35px",
                                                                            backgroundColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : '',
                                                                            borderColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : ''
                                                                        }}
                                                                    >
                                                                        {/* Mark Complete */}
                                                                        {item?.associatedTasks?.status === "completed" ? "Completed" : 'Mark Complete'}
                                                                    </Button>                                </div>
                                                                <div className='group-details-table'>
                                                                    <TableLayout column={column} data={item?.occurrences || []} />
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </Container>
                                            </section>
                                        </>
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                    )
                }
            </Accordion>
        </>
    )
}
